
import { useAnimation } from "framer-motion";
import { useCallback } from "react";
import type { Container, Engine } from "@tsparticles/engine";
import { useParticles } from "../ParticlesContext";

export const useParticlesLoaded = () => {
  const controls = useAnimation();
  const { isInitialized, setEngine } = useParticles();

  const particlesLoaded = useCallback(async (container?: Container) => {
    if (container) {
      // Type-safe extraction of engine from container
      const engineRef = (container as any).engine as Engine | undefined;
      
      if (engineRef) {
        // Store engine reference in context for reuse
        setEngine?.(engineRef);
      }
      
      controls.start({
        opacity: 1,
        transition: {
          duration: 0.6,
        },
      });
    }
  }, [controls, setEngine]);

  return { 
    controls, 
    particlesLoaded, 
    isInitialized
  };
};
